export const countryList = [
  "United States (US)",
  "Afghanistan (AF)",
  "Albania (AL)",
  "Algeria (DZ)",
  "Andorra (AD)",
  "Angola (AO)",
  "Anguilla (AI)",
  "Antigua (AG)",
  "Argentina (AR)",
  "Armenia (AM)",
  "Aruba (AW)",
  "Australia (AU)",
  "Austria (AT)",
  "Azerbaijan (AZ)",
  "Bahamas (BS)",
  "Bahrain (BH)",
  "Bangladesh (BD)",
  "Barbados (BB)",
  "Belarus (BY)",
  "Belgium (BE)",
  "Belize (BZ)",
  "Benin (BJ)",
  "Bermuda (BM)",
  "Bhutan (BT)",
  "Bolivia (BO)",
  "Bonaire (XB)",
  "Bosnia & Herzegovina (BA)",
  "Botswana (BW)",
  "Brazil (BR)",
  "Brunei (BN)",
  "Bulgaria (BG)",
  "Burkina Faso (BF)",
  "Burundi (BI)",
  "Cambodia (KH)",
  "Cameroon (CM)",
  "Canada (CA)",
  "Canary Islands, The (IC)",
  "Cayman Islands (KY)",
  "Chad (TD)",
  "Chile (CL)",
  "China (CN)",
  "Colombia (CO)",
  "Congo (CG)",
  "Congo, DPR (CD)",
  "Costa Rica (CR)",
  "Cote D Ivoire (CI)",
  "Croatia (HR)",
  "Curacao (XC)",
  "Cyprus (CY)",
  "Czech Rep., The (CZ)",
  "Denmark (DK)",
  "Djibouti (DJ)",
  "Dominica (DM)",
  "Dominican Rep. (DO)",
  "Ecuador (EC)",
  "Egypt (EG)",
  "El Salvador (SV)",
  "Eritrea (ER)",
  "Estonia (EE)",
  "Eswatini (SZ)",
  "Ethiopia (ET)",
  "Fiji (FJ)",
  "Finland (FI)",
  "France (FR)",
  "French Guyana (GF)",
  "Gabon (GA)",
  "Gambia (GM)",
  "Georgia (GE)",
  "Germany (DE)",
  "Ghana (GH)",
  "Gibraltar (GI)",
  "Greece (GR)",
  "Grenada (GD)",
  "Guadeloupe (GP)",
  "Guatemala (GT)",
  "Guernsey (GG)",
  "Guinea Rep. (GN)",
  "Guinea-Equatorial (GQ)",
  "Guyana (British) (GY)",
  "Haiti (HT)",
  "Honduras (HN)",
  "Hong Kong China (HK)",
  "Hungary (HU)",
  "Iceland (IS)",
  "India (IN)",
  "Indonesia (ID)",
  "Iran (IR)",
  "Iraq (IQ)",
  "Ireland, Rep. Of (IE)",
  "Israel (IL)",
  "Italy (IT)",
  "Jamaica (JM)",
  "Japan (JP)",
  "Jersey (JE)",
  "Jordan (JO)",
  "Kazakhstan (KZ)",
  "Kenya (KE)",
  "Kuwait (KW)",
  "Kyrgyzstan (KG)",
  "Laos (LA)",
  "Latvia (LV)",
  "Lebanon (LB)",
  "Liberia (LR)",
  "Libya (LY)",
  "Liechtenstein (LI)",
  "Lithuania (LT)",
  "Luxembourg (LU)",
  "Macau SAR China (MO)",
  "Macedonia (MK)",
  "Madagascar (MG)",
  "Malawi (MW)",
  "Malaysia (MY)",
  "Maldives (MV)",
  "Mali (ML)",
  "Malta (MT)",
  "Marshall Islands (MH)",
  "Martinique (MQ)",
  "Mauritius (MU)",
  "Mayotte (YT)",
  "Mexico (MX)",
  "Micronesia (FM)",
  "Moldova (MD)",
  "Monaco (MC)",
  "Mongolia (MN)",
  "Montenegro, Rep Of (ME)",
  "Montserrat (MS)",
  "Morocco (MA)",
  "Mozambique (MZ)",
  "Myanmar (MM)",
  "Namibia (NA)",
  "Nepal (NP)",
  "Netherlands (NL)",
  "Nevis (XN)",
  "New Caledonia (NC)",
  "New Zealand (NZ)",
  "Nicaragua (NI)",
  "Niger (NE)",
  "Nigeria (NG)",
  "North Korea (KP)",
  "Norway (NO)",
  "Oman (OM)",
  "Pakistan (PK)",
  "Palau (PW)",
  "Palestine (PS)",
  "Panama (PA)",
  "Papua New Guinea (PG)",
  "Paraguay (PY)",
  "Peru (PE)",
  "Philippines, The (PH)",
  "Poland (PL)",
  "Portugal (PT)",
  "Qatar (QA)",
  "Reunion, Island Of (RE)",
  "Romania (RO)",
  "Russia (RU)",
  "Rwanda (RW)",
  "Saint Helena (SH)",
  "Samoa (WS)",
  "San Marino (SM)",
  "Saudi Arabia (SA)",
  "Senegal (SN)",
  "Serbia, Rep. Of (RS)",
  "Seychelles (SC)",
  "Singapore (SG)",
  "Slovakia (SK)",
  "Slovenia (SI)",
  "Solomon Islands (SB)",
  "Somalia (SO)",
  "South Africa (ZA)",
  "South Korea, Rep. Of (KR)",
  "South Sudan (SS)",
  "Spain (ES)",
  "Sri Lanka (LK)",
  "St. Barthelemy (XY)",
  "St. Eustatius (XE)",
  "St. Kitts (KN)",
  "St. Lucia (LC)",
  "St. Maarten (XM)",
  "St. Vincent (VC)",
  "Sudan (SD)",
  "Suriname (SR)",
  "Sweden (SE)",
  "Switzerland (CH)",
  "Syria (SY)",
  "Taiwan (TW)",
  "Tajikistan (TJ)",
  "Tanzania (TZ)",
  "Thailand (TH)",
  "Timor-Leste (TL)",
  "Togo (TG)",
  "Tonga (TO)",
  "Trinidad And Tobago (TT)",
  "Tunisia (TN)",
  "Turkey (TR)",
  "Turkmenistan (TM)",
  "Turks & Caicos (TC)",
  "Tuvalu (TV)",
  "Uganda (UG)",
  "Ukraine (UA)",
  "United Arab Emirates (AE)",
  "United Kingdom - England, Scotland, Wales and Northern Ireland (GB)",
  "Uruguay (UY)",
  "Uzbekistan (UZ)",
  "Vanuatu (VU)",
  "Vatican City (VA)",
  "Venezuela (VE)",
  "Vietnam (VN)",
  "Virgin Islands-British (VG)",
  "Yemen (YE)",
  "Zambia (ZM)",
  "Zimbabwe (ZW)"
];
